import api from 'Application/api/api';

const hideProjectQuestion = (projectId, questionId, isCustom, cancelToken = null) =>
    api.post(
        `project-manager/projects/${projectId}/questionnaire/questions/${questionId}/${
            isCustom ? 1 : 0
        }/hide`,
        {},
        { cancelToken },
    );

export default hideProjectQuestion;
